module.exports = __webpack_public_path__ + "img/vibranium-hint.e338d133.jpg";